import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type { DeleteApiTokenRequestDto } from '../model';

const deleteApiToken = async (
  args: DeleteApiTokenRequestDto,
  options?: RequestHandlerOptions
): Promise<void> => {
  const request = () =>
    apiClient.post('/security/trading/webapi/token/delete', args);
  const response = await handleRequest<void>(request, options);
  return response.data;
};

export { deleteApiToken };
